import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';

import { EInventoryParamType } from '@ruby/shared/enums/inventory-management.enums';
import { IInventory, IInventoryToolTipParams } from '@ruby/shared/models/inventory-management/inventory-header.interface';

@Component({
  selector: 'ng-info-tooltip',
  templateUrl: './info-tooltip.component.html',
  styleUrls: ['./info-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoToolTipComponent implements ITooltipAngularComp {
  params!: IInventoryToolTipParams;
  data!: IInventory;
  value!: string;

  constructor() { }

  get showServiceCredits(): boolean {
    return this.params.type === EInventoryParamType.SERVICE_CREDITS && !!this.data.serviceCreditToolTip;
  }

  get showAdjustedCredits(): boolean {
    return this.params.type === EInventoryParamType.ADJUSTED_CREDITS && !!this.data.adjustedCreditToolTip;
  }

  get showCredits(): boolean {
    return this.params.type === EInventoryParamType.CREDITS && !!(this.data.creditsToolTip || this.data.creditToolTip);
  }

  get showApprovedBy(): boolean {
    return this.params.type === EInventoryParamType.APPROVED_BY && !!(this.data.approvedByToolTip || this.data.approvedBytimeStampDisplay);
  }

  get serviceCredits(): Array<string> {
    return this.data.serviceCreditToolTip.split('\r');
  }

  agInit(params: ITooltipParams): void {
    this.params = params as IInventoryToolTipParams;
    this.data = params.data;
    this.value = params.value;
  }
}
